import { useState, useEffect, useCallback } from "react";
import { getRelatedInfo } from "../../api/positionApi";

export const useGetRelatedInfo = (positionId: string | number) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    if (!positionId) return;

    try {
      setLoading(true);
      setError(null);
      const result = await getRelatedInfo(positionId);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Unknown error"));
    } finally {
      setLoading(false);
    }
  }, [positionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
